import { Record } from "immutable";

import { TranslatableMap } from "@localisation/models";

export type PermissionLevel = "system" | "organisation" | "user";

interface PermissionLevelsMap {
    [key: number]: PermissionLevel;
}

export interface IUser {
    id?: number;
    name?: string;
    email?: string;
    password?: string;
    createdAt?: Date;
    updatedAt?: Date;
    organisation?: number;
    roles?: string[];
    permissionsLevels?: PermissionLevelsMap;
}

export interface IOrganisation {
    id?: number;
    name?: string;
    createdAt?: Date;
    updatedAt?: Date;
}

export interface IRole {
    id?: number;
    name?: string;
    label?: TranslatableMap;
    level?: number;
    createdAt?: Date;
    updatedAt?: Date;
    permissions?: number[];
}

export interface IPermission {
    id?: number;
    name?: string;
    type?: string;
}

const UserRecord = Record({
    id: undefined,
    name: undefined,
    email: undefined,
    password: undefined,
    createdAt: undefined,
    updatedAt: undefined,
    organisation: undefined,
    roles: undefined,
    permissionsLevels: undefined,
});

const OrganisationRecord = Record({
    id: undefined,
    name: undefined,
    createdAt: undefined,
    updatedAt: undefined,
});

const RoleRecord = Record({
    id: undefined,
    name: undefined,
    label: undefined,
    level: undefined,
    createdAt: undefined,
    updatedAt: undefined,
    permissions: undefined,
});

const PermissionRecord = Record({
    id: undefined,
    name: undefined,
    type: undefined,
});

export class User extends UserRecord implements IUser {
    public id: number;
    public name: string;
    public email: string;
    public password: string;
    public createdAt: Date;
    public updatedAt: Date;
    public organisation: number;
    public roles: string[];
    public permissionsLevels: PermissionLevelsMap;
}

export class Organisation extends OrganisationRecord implements IOrganisation {
    public id: number;
    public name: string;
    public createdAt: Date;
    public updatedAt: Date;
}

export class Role extends RoleRecord implements IRole {
    public id: number;
    public name: string;
    public label: TranslatableMap;
    public level: number;
    public createdAt: Date;
    public updatedAt: Date;
    public permissions: number[];
}

export class Permission extends PermissionRecord implements IPermission {
    public id: number;
    public name: string;
    public type: string;
}
